import type { LedgerCollapse } from './types';

/**
 * One collapse point per screen, driven by container queries rather than
 * viewport breakpoints: the ledger reacts to the width it is given, not the
 * width of the window (side panels and sidebars change one without the other).
 */

/** Style the element that owns the query context. Screens apply this once. */
export function ledgerContainerSx(container: string) {
  return {
    containerType: 'inline-size',
    containerName: container,
  };
}

export function containerMaxWidthQuery(container: string, px: number): string {
  return `@container ${container} (max-width: ${px}px)`;
}

/** Hide at or below an explicit width inside the named container. */
export function hideBelowWidthSx(container: string, px: number) {
  return {
    [containerMaxWidthQuery(container, px)]: { display: 'none' },
  };
}

/** Hide at or below the screen's collapse point (columns, band totals). */
export function hideBelowSx(collapse: LedgerCollapse) {
  return hideBelowWidthSx(collapse.container, collapse.at);
}

/** Show only at or below the collapse point (the row meta line). */
export function showBelowSx(collapse: LedgerCollapse, display = 'block') {
  return {
    display: 'none',
    [containerMaxWidthQuery(collapse.container, collapse.at)]: { display },
  };
}
